import React from 'react';
import { Portal } from 'react-portal';
import { AnimatePresence, motion } from 'framer-motion';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';
import ModalOverlay from './ModalOverlay';
import { ModalProps } from './ModalProps';

const Layout = styled(motion.div)<Partial<ModalProps>>`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${theme.zIndex.modal};
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0 ${toRem(22)};
  background-color: transparent;
  overflow: auto;

  @media (min-width: ${theme.breakpoint.med}px) {
    padding: 0;
  }

  ${({ sticky }) =>
    sticky &&
    css`
      justify-content: flex-start;

      @media (min-width: ${theme.breakpoint.med}px) {
        justify-content: center;
        padding: 0;
        overflow: hidden;
      }
    `}
`;

interface IModalContainerProps extends ModalProps {
  className?: string;
  closeOnOutSideClick?: boolean;
}

export const ModalContainer: React.FC<IModalContainerProps> = ({ isActive, closeOnOutSideClick = true, onClose, sticky, children, className, dataCy = 'modal' }) => (
  <Portal>
    <AnimatePresence>
      {isActive && (
        <>
          <Layout sticky={sticky} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ ease: 'easeInOut', duration: 0.2 }} className={className} data-cy={dataCy}>
            {children}
            <ModalOverlay {...(closeOnOutSideClick && { onClick: onClose })} data-cy="modal-overlay" />
          </Layout>
        </>
      )}
    </AnimatePresence>
  </Portal>
);
